import { Input } from '../../ui';
import { useFieldContext } from '../FieldContext';

export function NumberInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  return (
    <Input
      type="number"
      inputMode="decimal"
      value={typeof value === 'number' ? String(value) : ''}
      // An empty box means "no value", not zero.
      onChange={(event) => onChange(event.target.value === '' ? null : Number(event.target.value))}
      disabled={readOnly}
      aria-label={field.label}
      className="tabular-nums"
    />
  );
}
